module.exports = __webpack_public_path__ + "media/blog/facebook-7a4110cf.png";